const anoAtual = new Date().getFullYear()
const mesAtual = new Date().getMonth() + 1

export const monthsList = (cardYear) => {
  const mesesArray = [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12]
  let newMonthArray = mesesArray.filter((month) => month >= mesAtual)
  let finalMonthArray

  const minDigit = (number) => {
    return (number < 10 ? '0' : '') + number
  }

  if (cardYear == anoAtual) {
    finalMonthArray = newMonthArray.map((item) => {
      // return { label: `${minDigit(item)}`, value: `${item}` }
      switch (item) {
        case 1:
          return { label: 'Janeiro', value: `${item}` }
        case 2:
          return { label: 'Fevereiro', value: `${item}` }
        case 3:
          return { label: 'Março', value: `${item}` }
        case 4:
          return { label: 'Abril', value: `${item}` }
        case 5:
          return { label: 'Maio', value: `${item}` }
        case 6:
          return { label: 'Junho', value: `${item}` }
        case 7:
          return { label: 'Julho', value: `${item}` }
        case 8:
          return { label: 'Agosto', value: `${item}` }
        case 9:
          return { label: 'Setembro', value: `${item}` }
        case 10:
          return { label: 'Outubro', value: `${item}` }
        case 11:
          return { label: 'Novembro', value: `${item}` }
        case 12:
          return { label: 'Dezembro', value: `${item}` }
        default:
          break
      }
    })
  } else {
    finalMonthArray = mesesArray.map((item) => {
      // return { label: `${minDigit(item)}`, value: `${item}` }
      switch (item) {
        case 1:
          return { label: 'Janeiro', value: `${item}` }
        case 2:
          return { label: 'Fevereiro', value: `${item}` }
        case 3:
          return { label: 'Março', value: `${item}` }
        case 4:
          return { label: 'Abril', value: `${item}` }
        case 5:
          return { label: 'Maio', value: `${item}` }
        case 6:
          return { label: 'Junho', value: `${item}` }
        case 7:
          return { label: 'Julho', value: `${item}` }
        case 8:
          return { label: 'Agosto', value: `${item}` }
        case 9:
          return { label: 'Setembro', value: `${item}` }
        case 10:
          return { label: 'Outubro', value: `${item}` }
        case 11:
          return { label: 'Novembro', value: `${item}` }
        case 12:
          return { label: 'Dezembro', value: `${item}` }
        default:
          break
      }
    })
  }

  finalMonthArray.splice(0, 0, {
    label: 'Mês',
    value: '',
    hidden: true,
    disabled: true
  })

  return finalMonthArray
}

export const yearsList = (range) => {
  let arr = []
  for (let i = anoAtual; i <= anoAtual + range; i++) arr.push(i)

  let newArray = arr.map((item) => {
    return { label: `${item}`, value: `${item}` }
  })

  newArray.splice(0, 0, {
    label: 'Ano',
    value: '',
    hidden: true,
    disabled: true
  })

  return newArray
}
